// @flow strict

import * as React from 'react';
import cx from 'classnames';
import styles from './styles.scss';

type PropTypes = {|
  children: React.Node,
  className?: string,
  variant: 'Default' | 'Secondary',
  isDarkBackground?: boolean,
|};

const FormattedContent = (props: PropTypes) => {
  return (
    <div
      className={cx(
        styles.formattedContent,
        props.className,
        props.variant === 'Secondary' && styles.secondary,
        props.isDarkBackground && styles.contrastedLink,
      )}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={
        typeof props.children === 'string' ? { __html: props.children } : undefined
      }
    >
      {typeof props.children !== 'string' ? props.children : undefined}
    </div>
  );
};

FormattedContent.defaultProps = {
  variant: 'Default',
  isDarkBackground: false,
};

export default FormattedContent;
